import * as L from 'leaflet';
import 'leaflet-imageoverlay-rotated';
import { useLocalStorageOverlay } from '@/utils/map/layer';

const PANE_NAME = 'overlayImages';
// Between Leaflet's tilePane (200) and overlayPane (400), so geofences, tracks and markers draw on top.
const PANE_Z_INDEX = 250;

export function createOverlayPane(map: L.Map) {
  if (!map.getPane(PANE_NAME)) {
    map.createPane(PANE_NAME);
    map.getPane(PANE_NAME)!.style.zIndex = String(PANE_Z_INDEX);
  }
}

export function addOverlayIfEnabled(
  map: L.Map,
  layer: L.Layer,
  name: string,
  initialValue = true,
) {
  const { is } = useLocalStorageOverlay(name, initialValue);
  if (is) {
    layer.addTo(map);
  }
  return is;
}

export function renderMapOverlays(
  map: L.Map,
  overlays: any[],
  layerGroup: L.LayerGroup,
) {
  layerGroup.clearLayers();
  if (!map || !overlays?.length) return;

  overlays.forEach((overlay) => {
    if (
      !overlay.corners?.topLeft ||
      !overlay.corners?.topRight ||
      !overlay.corners?.bottomLeft
    )
      return;

    const url = overlay.file?.url;
    if (!url) return;

    const topLeft = L.latLng(overlay.corners.topLeft.lat, overlay.corners.topLeft.lng);
    const topRight = L.latLng(overlay.corners.topRight.lat, overlay.corners.topRight.lng);
    const bottomLeft = L.latLng(
      overlay.corners.bottomLeft.lat,
      overlay.corners.bottomLeft.lng,
    );

    const layer = (L as any).imageOverlay.rotated(url, topLeft, topRight, bottomLeft, {
      opacity: overlay.opacity ?? 1,
      pane: PANE_NAME,
    });

    layer.addTo(layerGroup);
  });
}

export function clearMapOverlays(layerGroup: L.LayerGroup) {
  layerGroup.clearLayers();
}
